export default {
    selectorCache: function() {
        "use strict";
        
        var elementCache = {};
        var GET_FROM_CACHE = function( selector, $ctxt, reset ) {
                if ( "boolean" === typeof $ctxt ) {
                    reset = $ctxt;
                    $ctxt = false;
                }

                var cacheKey = $ctxt ? $ctxt.selector + " " + selector : selector;

                if ( undefined === elementCache[ cacheKey ] || reset ) {
                    elementCache[ cacheKey ] = $ctxt ? $ctxt.find( selector ) : jQuery( selector );
                }

                return elementCache[ cacheKey ];
            };

        GET_FROM_CACHE.elementCache = elementCache;
        
        return GET_FROM_CACHE;
    }
};
